"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
var startFunction;
var interruptFunction;

var _pendingEventListeners = [];
var gameIframe = null;
var gameOrigin = null;

/**
* gameProxy exists as a backwards compatible facade
* that the existing games call. It interfaces with GameManager.
* 
* When GameManager.init() is called, the global PCH.gameProxy variable points to this instance with a reference to the calling GameManager instance.
*
* Existing games call gameProxy as usual without change.
*
* @namespace gameProxy
*/
var gameProxy = {
    /**
    * initalize game once iframe is loaded
    * @param {object} args
    *   @param {object} args.user
    *   @param {object} [args.game]
    *   @param {object} [args.data]
    */
    initGame: function initGame(args) {
        var gameJson = args.game || args.data && args.data.item || {};
        if (gameIframe) {
            var msg = {
                command: "initgame",
                args: {
                    domain: window.location.protocol + '//' + window.location.hostname,
                    name: "initgame",
                    user: args.user,
                    game: gameJson
                }
            };
            gameIframe.contentWindow.postMessage(JSON.stringify(msg), "*");
        } else {
            startFunction({
                user: args.user,
                game: gameJson,
                data: JSON.parse(JSON.stringify(args))
            });
        }
    },
    /**
    * send gameEvent data for backend service
    * @param {string} event
    * @param {object} data
    * @param {function} cb
    */
    gameEvent: function gameEvent(event, data, cb) {
        console.log("gameEvent", event, data);

        var _cb = sendCallbackResponse.bind(null, cb);
        switch (event) {
            case "start":
                this.manager.startGame(data);
                if (cb) {
                    this.manager.gameModel.onStarted.then(_cb).catch(_cb);
                }
                break;
            case "end":
                this.manager.endGame(data);
                if (cb) {
                    this.manager.gameModel.onEnded.then(_cb).catch(_cb);
                }
                break;
            default:
                this.manager.gameEvent(event, data, function (err, resp) {
                    if (!cb) {
                        return;
                    }
                    if (err) {
                        sendCallbackResponse(cb, err);
                    } else {
                        sendCallbackResponse(cb, resp);
                    }
                });
                //this.manager.dispatchEvent(data);
                break;
        }
    },
    /**
    * gameStart alias to gameEvent
    * Sends the "start" event
    * @param {function} cb
    */
    gameStart: function gameStart(cb) {
        this.gameEvent("start", null, cb);
        //this.gameStart = function() {}; // only callable once
    },
    /**
    * gameEnd alias to gameEvent
    * Sends the "end" event
    * @param {function} cb
    */
    gameEnd: function gameEnd(cb) {
        this.gameEvent("end", null, cb);
        //this.gameEnd = function() {}; // only callable once
    },
    /**
    * function the game registers to be called later to start the game
    * @param {function} fn - The callback to fire when the game is ready
    */
    registerStartFunction: function registerStartFunction(fn) {
        startFunction = fn;
        this.registerLoaded();
    },
    /**
    * function game registers to be called when interrupt is fired
    * @param {function} fn - callback to fire when the game is interrupted
    */
    registerInterruptFunction: function registerInterruptFunction(fn) {
        interruptFunction = fn;
    },
    /**
    * Interrupt the game
    * Will call the previously registered interrupt callback
    * @param {*} args - mixed args to send to the interrupt callback
    */
    interruptGame: function interruptGame(args) {
        if (interruptFunction) {
            interruptFunction(args);
        }
    },
    /**
    * Set the game manager to interface with
    * @param {GameManager} manager
    */
    setGameManager: function setGameManager(manager) {
        this.manager = manager;
        this.registerLoaded();
        if (_pendingEventListeners.length > 0) {
            for (var i = 0, n = _pendingEventListeners.length; i < n; i++) {
                this.manager.on.apply(this.manager, _pendingEventListeners[i]);
            }
            _pendingEventListeners = [];
        }
    },
    /**
    * Returns whether the given manager is the current one set for the gameProxy to interface withj
    * @param {GameManager}
    * @returns {bool}
    */
    isCurrentManager: function isCurrentManager(manager) {
        return manager === this.manager;
    },
    registerLoaded: function registerLoaded() {
        var _this = this;

        if (this.manager && (startFunction || this.manager.gameModel.isIframeGame())) {
            this.manager.gameModel.onLoaded.then(function (iframe) {
                setGameIframe(iframe);
                _this.initGame(_this.manager.gameModel);
            });
        }
    },

    /**
    * Reset the gameProxy state
    */
    resetProxy: function resetProxy() {
        _pendingEventListeners = [];
        this.manager = null;
        startFunction = null;
        interruptFunction = null;
        if (gameIframe) {
            gameIframe = null;
            gameOrigin = null;
            window.removeEventListener('message', handleIframeMessage, false);
        }
    },

    /**
    * pub/sub proxying to game manager
    * add event listener
    * @see external:EventsMixin for arguments
    */
    on: function on() {
        if (this.manager) {
            return this.manager.on.apply(this.manager, arguments);
        } else {
            _pendingEventListeners.push(Array.prototype.slice.call(arguments));
        }
    },
    /**
    * alias to on()
    */
    addEventListener: function addEventListener() {
        // alias to on()
        return this.on.apply(this, arguments);
    },

    /**
    * remove event listener
    * @see external:EventsMixin for arguments
    */
    off: function off() {
        if (this.manager) {
            return this.manager.off.apply(this.manager, arguments);
        } else if (_pendingEventListeners.length > 0) {
            var args = Array.prototype.slice.call(arguments);
            var toRemove = [];
            for (var i = 0, n = _pendingEventListeners.length; i < n; i++) {
                if (arraysEqual(_pendingEventListeners[i], args)) {
                    toRemove.push(i);
                }
            }
            for (i = 0, n = toRemove.length; i < n; i++) {
                _pendingEventListeners.splice(i, 1);
            }
        }
    },
    /**
    * alias to off()
    */
    removeEventListener: function removeEventListener() {
        // alias to off()
        return this.off.apply(this, arguments);
    },

    /**
    * fire event
    * @see external:EventsMixin for arguments
    */
    fireEvent: function fireEvent() {
        if (this.manager) {
            return this.manager.fireEvent.apply(this.manager, arguments);
        }
    }
};

function sendCallbackResponse(cb, resp) {
    if (!resp) {
        cb({});
    } else if (resp.body.data && resp.body.data.iw_response) {
        cb(resp.body.data && resp.body.data.iw_response);
    } else if (resp.body.iw_response) {
        cb(resp.body.iw_response);
    } else if (resp.body.data) {
        cb(resp.body.data);
    } else {
        cb(resp.body);
    }
}

function arraysEqual(a, b) {
    if (a === b) {
        return true;
    }
    if (a === null || b === null) {
        return false;
    }
    if (a.length != b.length) {
        return false;
    }

    // If you don't care about the order of the elements inside
    // the array, you should sort both arrays here.
    for (var i = 0; i < a.length; ++i) {
        if (a[i] !== b[i]) {
            return false;
        }
    }
    return true;
}

function handleIframeMessage(ev) {
    var evData = ev.data;
    if (ev.origin != gameOrigin) {
        return;
    }
    if (typeof evData === 'string') {
        evData = JSON.parse(evData);
    }
    var name = evData.name || evData.event;
    if (!name) {
        return;
    }
    var gamedata = evData.args || evData.gamedata || {};
    var callbackID = evData.callbackID;
    gameProxy.gameEvent(name, gamedata, function (args) {
        var msg = { args: args };
        if (callbackID) {
            msg.callback = callbackID;
        } else {
            msg.name = name;
        }
        gameIframe.contentWindow.postMessage(JSON.stringify(msg), '*');
    });
}

function setGameIframe(iframe) {
    if (iframe) {
        gameIframe = iframe;
        gameOrigin = iframe.src.replace(/^\/\//, window.location.protocol).replace(/(https?:\/\/[^\/]+).*$/, '$1');
        window.addEventListener("message", handleIframeMessage, false);
    }
}

// we need to set a global reference to our gameProxy
// because this is what the games call
window.PCH = window.PCH || {};
window.PCH.gameProxy = gameProxy;

// make the internal object public
exports.default = gameProxy;